import api from "PFCore/api";

export type ForgotPasswordPayload = {
  accountId: number;
  email: string;
};

type ForgotPasswordResponse = {
  message: string;
};

export const forgotPassword = (user: ForgotPasswordPayload, forceSendEmail?: boolean) =>
  api<ForgotPasswordResponse>({
    url: "auth/forgot_password",
    method: "POST",
    apiVersion: 1,
    data: {
      user,
      ...(forceSendEmail ? { forceSendEmail } : {})
    }
  });
